import PropTypes from "prop-types";
import React from "react";
import styles from "./DisclosurePublishCard.module.css";

const STATUS_OPTIONS = [
  { value: "Archived", color: "#ed1f24" },
  { value: "In Review", color: "#91b6bb" },
  { value: "Published", color: "#43ba32" },
];

export function DisclosurePublishCard({ status, onChange }) {
  return (
    <section className={styles.card}>
      <h3 className={styles.heading}>Publish</h3>
      <div className={styles.divider} />
      <div className={styles.statusRow}>
        <span className={styles.label}>Status</span>
        <div
          className={styles.statusGroup}
          role="group"
          aria-label="Disclosure status"
        >
          {STATUS_OPTIONS.map((option) => {
            const active = status === option.value;
            return (
              <button
                key={option.value}
                type="button"
                className={styles.statusButton}
                style={{
                  borderColor: option.color,
                  background: active ? option.color : "#ffffff",
                  color: active ? "#ffffff" : option.color,
                }}
                aria-pressed={active}
                onClick={() => onChange(option.value)}
              >
                {option.value}
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}

DisclosurePublishCard.propTypes = {
  status: PropTypes.oneOf(["Archived", "In Review", "Published"]),
  onChange: PropTypes.func.isRequired,
};

DisclosurePublishCard.defaultProps = {
  status: "In Review",
};

export default DisclosurePublishCard;
